<template>
  <div class="block-container">
    <TextBody tag="span" i18n-key="translation.translatedFile" :body-type="2" weight="medium" color="#000" />
    <DocumentCard
      :data="data"
      @title-clicked="openPdfViewer(data.targetLanguage)"
      @button-clicked="downloadTranslatedFile"
      :to-download="true"
    />
    <TextBody tag="span" i18n-key="translation.sourceFile" :body-type="2" weight="medium" color="#000" />
    <DocumentCard :data="data" @title-clicked="openViewerSourceFile(data.sourceLanguage)" />
  </div>
</template>
<script>
import { onMounted } from 'vue';

import { CURRENT_DIALOG } from '~/constants/conversationModels';

import useDocuments from '~/composables/useDocuments';
import useModals from '~/composables/useModals';
import { isTempDocument } from '~/utils/document-utils';
import TextBody from '~/components/common/TextBody';
import DocumentCard from '~/components/conversation/chatMessage/DocumentCard';

export default {
  components: { DocumentCard, TextBody },
  props: {
    messageId: {
      type: String,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },

  setup(props) {
    const { getPdfUrl, getSourceUrl, updateSystemMessageTranslationData, setSelectedDocument } = useDocuments();
    const { setCurrentDocumentsDialog, showPreviewDocument } = useModals();

    const openPdfViewer = async (language) => {
      await setSelectedDocument({ reference: props.data, isMetadata: false, language });
      showPreviewDocument(1);
    };

    const openViewerSourceFile = async (language) => {
      if (isTempDocument(props.data.externalId)) {
        await openPdfViewer(language);
      } else {
        await setSelectedDocument({ reference: props.data });
        setCurrentDocumentsDialog(CURRENT_DIALOG.document_panel);
      }
    };

    const downloadTranslatedFile = async () => {
      const url =
        props.data.type === 'documentTranslation'
          ? await getPdfUrl(props.data.externalId, props.data.targetLanguage)
          : await getSourceUrl(props.data.externalId, props.data.targetLanguage);
      window.open(url || '');
    };

    onMounted(async () => {
      // get thumbs for the documents
      await updateSystemMessageTranslationData(props.messageId, props.data);
    });

    return {
      downloadTranslatedFile,
      openPdfViewer,
      openViewerSourceFile,
    };
  },
};
</script>

<style scoped lang="scss">
.block-container {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-2;
  background-color: $bb-neutral-6;
  border-radius: 12px;
  padding: $bb-spacing-2 $bb-spacing-3 $bb-spacing-2 $bb-spacing-4;
}
</style>
